var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMinit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 23,
    viewBox: "0 0 39 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.69672 22.8253L7.12162 18.2733L5.17601 22.8385H4.57643L2.61859 18.2733L2.05572 22.8253H0L1.11352 14.9281H3.13253L4.8701 19.2309L6.61992 14.9281H8.63894L9.75245 22.8253H7.69672Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7422 14.9277H12.7979V22.8249H10.7422V14.9277Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6641 14.9009H30.7198V22.7981H28.6641V14.9009Z",
    fill: "#E61088"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7897 14.9282V22.8254H19.1133L16.1888 18.5357V22.8254H14.2188V14.9282H15.993L18.8197 19.0736V14.9282H20.7897Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7435 16.8824H25.749V22.8249H23.7055V16.8824H21.7109V14.9277H27.7435V16.8824Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M38.3216 16.8555H36.3271V22.7981H34.2836V16.8555H32.2891V14.9009H38.3216V16.8555Z",
    fill: "#E61088"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9463 0.931193C22.5914 0.222806 21.6737 0.222806 21.3188 0.931193L18.7859 5.82431L15.4453 12.3047H22.1264H28.8075L25.467 5.82431L22.9463 0.931193Z",
    fill: "#E61088"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8793 0.930704C16.5245 0.222317 15.6068 0.222317 15.2519 0.930704L12.7312 5.82382L9.39062 12.3042H16.0717H22.7528L19.4123 5.82382L16.8793 0.930704Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinit);
export default __webpack_public_path__ + "static/media/minit.242615f9cef31225138acf85d7d9de0e.svg";
export { ForwardRef as ReactComponent };